import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCopy, FiCheck } = FiIcons;

export default function CopyField({ label, value, multiline = false }) {
  const [copied, setCopied] = useState(false);

  async function copyValue() {
    await navigator.clipboard.writeText(value || '');
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1600);
  }

  return (
    <div className="copy-field">
      <label>{label}</label>
      <div className={multiline ? 'copy-value multiline' : 'copy-value'}>
        <span>{value || 'No value available'}</span>
        <button type="button" onClick={copyValue} disabled={!value} aria-label={`Copy ${label}`}>
          <SafeIcon icon={copied ? FiCheck : FiCopy} />
          {copied ? 'Copied' : 'Copy'}
        </button>
      </div>
    </div>
  );
}